import { OperationDefinition, TokenType } from './types';

export const operationDefinitions: OperationDefinition[] = [
  { key: 'is', label: 'is', shortLabel: 'is' },
  { key: 'is_not', label: 'is not', shortLabel: '!=' },
  { key: 'lt', label: 'before', shortLabel: '>' },
  { key: 'gt', label: 'after', shortLabel: '<' },
  { key: 'contains', label: 'contains', shortLabel: '∈' },
  { key: 'contains_not', label: 'does not contain', shortLabel: '∉' },
];

export function getDefaultOperationsForType(type: TokenType): string[] {
  switch (type) {
    case 'select':
      return ['is', 'is_not'];
    case 'text':
      return ['contains', 'is', 'is_not', 'contains_not'];
    case 'date':
      return ['is', 'lt', 'gt', 'is_not'];
    default:
      return ['is', 'is_not'];
  }
}
